import { isCustomDimension, isDimension, isNumericItem, } from '@lightdash/common';
// Warehouse totals and subtotals only re-aggregate metrics and table calcs.
// A numeric dimension is a group key, so it never gets a total.
export const canHaveWarehouseTotal = (item) => isNumericItem(item) && !isDimension(item) && !isCustomDimension(item);
